<template>
  <header id="header" :class="{ 'header-home' : $route.name === 'homePage' }">
    <!-- Header home -->
    <b-navbar class="navbar-home" toggleable="lg" type="light" variant="light" v-if="$route.name === 'homePage'">
      <div class="container">
        <b-navbar-brand to="/" data-aos="fade" data-aos-delay="200">
          <img src="public/images/logo.svg">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse">
          <i class="fa-sharp fa-regular fa-bars"></i>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="mx-auto nav-menu" data-aos="fade" data-aos-delay="400">
            <b-nav-item class="active" to="/">Busco Solución Legal</b-nav-item>
            <b-nav-item to="/afiliacion">Soy Abogado</b-nav-item>
            <b-nav-item to="/contacto">Contacto</b-nav-item>
            <b-nav-item class="d-lg-none mb-1 nav-focus" to="/login">Mi cuenta</b-nav-item>
            <b-nav-item class="d-lg-none nav-focus" to="/afiliacion">Afiliarse</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto d-none d-lg-flex" data-aos="fade" data-aos-delay="800">
            <b-nav-item class="nav-t-button" to="/login">Mi cuenta</b-nav-item>
            <b-nav-item class="nav-t-link" to="/afiliacion">Afiliarse <i class="fa-regular fa-circle-arrow-right icon-1"></i></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <!--  -->

    <!-- Header general -->
    <b-navbar class="navbar-general" toggleable="lg" type="dark" variant="info" v-else>
      <div class="container">
        <b-navbar-brand to="/" data-aos="fade" data-aos-delay="200">
          <img src="public/images/logo.svg">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/como-funciona"><i class="fa-light fa-circle-question mr-1"></i> ¿Cómo funciona?</b-nav-item>
            <b-nav-item to="/precios"><i class="fa-sharp fa-light fa-dollar-sign mr-1"></i> Precios</b-nav-item>
            <b-nav-item to="/nosotros"><i class="fa-thin fa-building mr-1"></i> Nosotros</b-nav-item>
            <b-nav-item to="/contacto"><i class="fa-light fa-envelope mr-1"></i> Contacto</b-nav-item>
            <b-nav-item to="/directorio"><i class="fa-light fa-book-open mr-1"></i> Directorio</b-nav-item>
            <b-nav-item to="/login"><i class="fa-light fa-right-to-bracket mr-1"></i> Sesión</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <!--  -->
  </header>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      
    }
  },

  mounted() {
  
  }
}
</script>